import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Route, useHistory } from 'react-router-dom';
import Navbar from '@rd-web-markets/market/dist/layout/Navbar/Navbar';
import Toast from '@rd-web-markets/shared/dist/util/toast/Toast';
import UnsavedChangesPromptBeforeUnload from '@rd-web-markets/shared/dist/components/UnsavedChangesPromptBeforeUnload';
import * as QueryString from 'query-string';
import ErrorHandler from '@components/util/ErrorHandler';
import UnexpectedSynchronousErrorBoundary from './UnexpectedSynchronousErrorBoundary';
import { translationsService } from '@services/translations.service';
import { APP_FOOTER_TEXT, APP_RELEASE_VERSION } from '@rd-web-markets/market/dist/constants';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { ProtectedClaimGroupDescendantPage } from '@rd-web-markets/shared/dist/util/ProtectedClaimGroupDescendantPage';
import ToastContainer from '@rd-web-markets/shared/dist/util/toast/ToastContainer';
import { redirectUserToAnotherAccountTypeRouteIfNecessary } from '@rd-web-markets/shared/dist/util/redirectUser';
import { useLoadTranslationsWithTooltips } from 'src/hooks/useLoadTranslationsWithTooltips';

export const ClientRoute = ({ component: Component, pageName, ...rest }) => {
  const user = useSelector((state) => state.auth.user);
  const [show, setShow] = useState(false);
  const [toastVariant, setToastVariant] = useState('success');
  const [message, setMessage] = useState(false);
  const history = useHistory();

  const handleToaster = (m, variant) => {
    variant ||= 'success';
    setShow(true);
    setMessage(m);
    setToastVariant(variant);
  }

  const translations = useLoadTranslationsWithTooltips(user, 'customer', translationsService);

  const isAClaimGroupSubroute = rest.path.includes(':claim_group_id') || rest.path.includes(':claimGroupId')
  const ProtectedPageComponent = (pageName && isAClaimGroupSubroute) ? ProtectedClaimGroupDescendantPage : null

  return (
    <Route {...rest} render={(props) => {
      if (user && user.account_type === 'customer') {
        if(!translations) return <Loading />;
        return (
          <>
            <UnsavedChangesPromptBeforeUnload />
            <ErrorHandler>
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  right: 0,
                  zIndex: 9999,
                  width: 'max-content'
                }}
              >
                <ToastContainer /> {/* uses redux */}
                <Toast show={show} message={message} variant={toastVariant} onClose={() => setShow(false)}/>
              </div>
              <Navbar userRole="customer" basename={rest.basename} {...props} />
              <div className="wrapper" id="content-wrapper">
                <Container fluid>
                  <UnexpectedSynchronousErrorBoundary>
                    { ProtectedPageComponent && 
                      <ProtectedPageComponent
                        renderPage={() => <Component {...props} handleToaster={handleToaster} accountType={user.account_type}/>}
                        pageName={pageName}
                      />
                    }

                    { !ProtectedPageComponent &&
                      <Component {...props} handleToaster={handleToaster} accountType={user.account_type}/>
                    }
                    
                    <div className="text-muted text-center" dangerouslySetInnerHTML={{ __html: `&copy; ${APP_FOOTER_TEXT}` }} >
                    </div>
                  </UnexpectedSynchronousErrorBoundary>
                </Container>
              </div>
            </ErrorHandler>
          </>
        );
      }
      else {
        redirectUserToAnotherAccountTypeRouteIfNecessary(user)
      }
    }} />
  )
}
